export default "__VITE_ASSET__4f090859__"